import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

export const archiveInfluencerApi = createApi({
  reducerPath: "archiveInfluencerApi",
  baseQuery: baseQuery,
  tagTypes: ["ArchiveInfluencer", "InfluencerPosts"],
  endpoints: (builder) => ({
    getArchiveRowCount: builder.query({
      query: ({ client, usernameContains, selectedLabels, selectedPlatforms, selectedDateRange }) => ({
        url: "/influencer_archive/get_influencer_posts_count",
        method: "POST",
        body: {
          client_name: client,
          username_contains: usernameContains,
          influencer_unique_labels: selectedLabels,
          influencer_platforms: selectedPlatforms,
          date_range: selectedDateRange,
        },
      }),
    }),
    getInfluencerPosts: builder.query({
      query: ({
        client,
        usernameContains,
        selectedLabels,
        page,
        pageSize,
        selectedPlatforms,
        selectedDateRange,
      }) => ({
        url: "/influencer_archive/get_influencer_posts",
        method: "POST",
        body: {
          client_name: client,
          username_contains: usernameContains,
          influencer_unique_labels: selectedLabels,
          page: page,
          page_size: pageSize,
          influencer_platforms: selectedPlatforms,
          date_range: selectedDateRange,
        },
      }),
    }),
    getUniqueLabels: builder.query({
      query: ({ client }) => ({
        url: "/influencer_archive/unique_labels",
        method: "GET",
        params: { client_name: client },
      }),
    }),
    getArchiveOutreachGraph: builder.query({
      query: ({
        client,
        startDate,
        endDate,
        granularity,
        isRolling,
        rollingWindow,
      }) =>
        "/influencer_archive/outreach_graph" +
        "?client=" +
        client +
        "&start_date=" +
        startDate +
        "&end_date=" +
        endDate +
        "&granularity=" +
        granularity +
        "&is_rolling=" +
        isRolling +
        "&rolling_window=" +
        rollingWindow,
    }),
  }),
});

export const {
  useGetArchiveOutreachGraphQuery,
  useGetInfluencerPostsQuery,
  useGetArchiveRowCountQuery,
  useGetUniqueLabelsQuery,
} = archiveInfluencerApi;

export default archiveInfluencerApi.reducer;